<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <!-- INCLUDED IN IMAGE PRICING -->
            <div class="hc-included-price row" style="background: #fff; margin-top: 80px;">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn" style>
                  <h1 class="section-title dark_title" style="color: #6773dd">
                    Choose a plan 
                  </h1>
                  <div
                    class="section-subtitle dark_subtitle"
                    style="color: #6773dd"
                  >
                    Find the right solution for your needs.
                  </div>
                </div>
              </div>
            </div>
            <div class="hc-included-price row" style="background: #7681e0; margin-top: 40px;">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn" style>
                  <h1 class="section-title dark_title" style="font-size: 28px;color: #fff">
                    Image Packages
                  </h1>
                  <div
                    class="section-subtitle dark_subtitle"
                    style="color: #fff"
                  >
                    All of your personal images are removed
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-included-price-cont horizontal-pricing-tables">
              <div class="container">
                <div class="row">
                  <div class="list-configurations col-sm-3">
                    <h1 class="wow fadeIn">Our Plans</h1>
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--business">
                            <div class="pricing__price">
                              <span class="pricing__currency"></span>
                            </div>
                            <p class="package__per__feature"></p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                Images
                                <span class="tooltiptext">Total number of images removed</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Days
                                <span
                                  class="tooltiptext"
                                >Actual number of days taken for image removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Detailed Report
                                <span
                                  class="tooltiptext"
                                >Details of the service provided on image removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature choose-items tooltip">
                                48 Hours
                                <span class="tooltiptext">Remove your images within 48 hours</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature choose-items tooltip">
                                Offenders Location
                                <span
                                  class="tooltiptext"
                                >Detects and reveals the first location or multiple locations where offender was operating</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Removal Limit
                                <span
                                  class="tooltiptext"
                                >We remove your images from any number of locations</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Counseling Psychologist
                                <span
                                  class="tooltiptext"
                                >Counselling helps you to get relief from the stress created by harassment</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Additional Images
                                <span
                                  class="tooltiptext"
                                >Additional images can be included for removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Initial Setup Fee
                                <span
                                  class="tooltiptext"
                                >No initial setup fee is charged for this service</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Customer Support
                                <span
                                  class="tooltiptext"
                                >You will be provided with 24x7 dedicated support service.</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="">Choose now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Basic</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{imageBasicCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                3
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                21
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imageBasic48Hours"
                                  type="radio"
                                  checked=""
                                  id="FSop1"
                                  name="FS1"
                                  value="0"
                                />
                                <label for="FSop1">21 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imageBasic48Hours"
                                  type="radio"
                                  id="FSop11"
                                  name="FS1"
                                  :value="packages.images.basic.hosted_48_hours"
                                />
                                <label for="FSop11">48 Hours ($ {{packages.images.basic.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imageBasicOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="FSop2"
                                  name="FS2"
                                  value="0"
                                />
                                <label for="FSop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imageBasicOffendersLocation"
                                  type="radio"
                                  id="FSop22"
                                  name="FS2"
                                  :value="packages.images.basic.sub_domains"
                                />
                                <label for="FSop22">Yes ($ {{packages.images.basic.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <select v-model="imageBasicAdditionalImages">
                                  <option value="0">0 images</option>
                                  <option v-for="index in packages.images.basic.additional_max_images" :key="index" :value="index">{{index}} images</option>
                                </select>
                                <span> ($ {{imageBasicAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="imageBasicDisabled" v-on:click.prevent="imageBasicSubmit">Choose now</a>
                            <span class="limit-exceeded">{{imageBasicDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Standard</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{imageStandardCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                6
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                14
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imageStandard48Hours"
                                  type="radio"
                                  checked=""
                                  id="PFop1"
                                  name="PF1"
                                  value="0"
                                />
                                <label for="PFop1">14 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imageStandard48Hours"
                                  type="radio"
                                  id="PFop11"
                                  name="PF1"
                                  :value="packages.images.standard.hosted_48_hours"
                                />
                                <label for="PFop11">48 Hours ($ {{packages.images.standard.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imageStandardOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="PFop2"
                                  name="PF2"
                                  :value="0"
                                />
                                <label for="PFop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imageStandardOffendersLocation"
                                  type="radio"
                                  id="PFop22"
                                  name="PF2"
                                  :value="packages.images.standard.sub_domains"
                                />
                                <label for="PFop22">Yes ($ {{packages.images.standard.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <select v-model="imageStandardAdditionalImages">
                                  <option value="0">0 images</option>
                                  <option v-for="index in packages.images.standard.additional_max_images" :key="index" :value="index">{{index}} images</option>
                                </select>
                                <span> ($ {{imageStandardAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="imageStandardDisabled" v-on:click.prevent="imageStandardSubmit">Choose now</a>
                            <span class="limit-exceeded">{{imageStandardDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-red col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--premium">
                            <div class="package__recommended">Premium</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{imagePremiumCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                10
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imagePremium48Hours"
                                  type="radio"
                                  checked=""
                                  id="BFop1"
                                  name="BF1"
                                  :value="0"
                                />
                                <label for="BFop1">7 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imagePremium48Hours"
                                  type="radio"
                                  id="BFop11"
                                  name="BF1"
                                  :value="packages.images.premium.hosted_48_hours"
                                />
                                <label for="BFop11">48 Hours ($ {{packages.images.premium.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="imagePremiumOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="BFop2"
                                  name="BF2"
                                  :value="0"
                                />
                                <label for="BFop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="imagePremiumOffendersLocation"
                                  type="radio"
                                  id="BFop22"
                                  name="BF2"
                                  :value="packages.images.premium.sub_domains"
                                />
                                <label for="BFop22">Yes ($ {{packages.images.premium.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <select v-model="imagePremiumAdditionalImages">
                                  <option value="0">0 images</option>
                                  <option v-for="index in packages.images.premium.additional_max_images" :key="index" :value="index">{{index}} images</option>
                                </select>
                                <span> ($ {{imagePremiumAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="imagePremiumDisabled" v-on:click.prevent="imagePremiumSubmit">Choose now</a>
                            <span class="limit-exceeded">{{imagePremiumDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- INCLUDED IN VIDEO PRICING -->
            <div class="clearfix"></div>
            <div class="hc-included-price row" style="background: #7681e0">
              <div class="col-sm-12">
                <div class="title-subtile-holder wow fadeIn" style>
                  <h1 class="section-title dark_title" style="color: #fff">
                    Video Packages
                  </h1>
                  <div
                    class="section-subtitle dark_subtitle"
                    style="color: #fff"
                  >
                    All of your personal videos are removed
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-included-price-cont horizontal-pricing-tables">
              <div class="container">
                <div class="row">
                  <div class="list-configurations col-sm-3">
                    <h1 class="wow fadeIn">Our Plan</h1>
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--business">
                            <div class="pricing__price">
                              <span class="pricing__currency"></span>
                            </div>
                            <p class="package__per__feature"></p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                Videos
                                <span class="tooltiptext">Total number of videos removed</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Days
                                <span
                                  class="tooltiptext"
                                >Actual number of days taken for video removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Detailed Report
                                <span
                                  class="tooltiptext"
                                >Details of the service provided on video removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature choose-items tooltip">
                                48 Hours
                                <span class="tooltiptext">Remove your video within 48 hours</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature choose-items tooltip">
                                Offenders Location
                                <span
                                  class="tooltiptext"
                                >Detects and reveals the first location or multiple locations where offender was operating</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Removal Limit
                                <span
                                  class="tooltiptext"
                                >We remove your video from any number of locations</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Counseling Psychologist
                                <span
                                  class="tooltiptext"
                                >Counselling helps you to get relief from the stress created by harassment</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Additional Videos
                                <span
                                  class="tooltiptext"
                                >Additional videos can be included for removal</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Initial Setup Fee
                                <span
                                  class="tooltiptext"
                                >No initial setup fee is charged for this service</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Customer Support
                                <span
                                  class="tooltiptext"
                                >You will be provided with 24x7 dedicated support service.</span>
                                <span class="fa fa-question-circle"></span>
                                <i class="fa fa-check-circle"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="">Choose now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Basic</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{videoBasicCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                1
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                21
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoBasic48Hours"
                                  type="radio"
                                  checked=""
                                  id="SSop1"
                                  name="SS1"
                                  :value="0"
                                />
                                <label for="SSop1">21 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoBasic48Hours"
                                  type="radio"
                                  id="SSop11"
                                  name="SS1"
                                  :value="packages.video.basic.hosted_48_hours"
                                />
                                <label for="SSop11">48 Hours ($ {{packages.video.basic.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoBasicOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="SSop2"
                                  name="SS2"
                                  :value="0"
                                />
                                <label for="SSop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoBasicOffendersLocation"
                                  type="radio"
                                  id="SSop22"
                                  name="SS2"
                                  :value="packages.video.basic.sub_domains"
                                />
                                <label for="SSop22">Yes ($ {{packages.video.basic.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature optn">
                                <select v-model="videoBasicAdditionalVideo">
                                  <option value="0">0 videos</option>
                                  <option v-for="index in packages.video.basic.additional_max_videos" :key="index" :value="index">{{index}} videos</option>
                                </select>
                                <span> ($ {{videoBasicAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="videoBasicDisabled" v-on:click.prevent="videoBasicSubmit">Choose now</a>
                            <span class="limit-exceeded">{{videoBasicDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-purple col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--simple">
                            <div class="package__recommended">Standard</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{videoStandardCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                3
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                14
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoStandard48Hours"
                                  type="radio"
                                  checked=""
                                  id="PSop1"
                                  name="PS1"
                                  :value="0"
                                />
                                <label for="PSop1">14 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoStandard48Hours"
                                  type="radio"
                                  id="PSop11"
                                  name="PS1"
                                  :value="packages.video.standard.hosted_48_hours"
                                />
                                <label for="PSop11">48 Hours ($ {{packages.video.standard.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoStandardOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="PSop2"
                                  name="PS2"
                                  :value="0"
                                />
                                <label for="PSop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoStandardOffendersLocation"
                                  type="radio"
                                  id="PSop22"
                                  name="PS2"
                                  :value="packages.video.standard.sub_domains"
                                />
                                <label for="PSop22">Yes ($ {{packages.video.standard.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature optn">
                                <select v-model="videoStandardAdditionalVideo">
                                  <option value="0">0 videos</option>
                                  <option v-for="index in packages.video.standard.additional_max_videos" :key="index" :value="index">{{index}} videos</option>
                                </select>
                                <span> ($ {{videoStandardAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="videoStandardDisabled" v-on:click.prevent="videoStandardSubmit">Choose now</a>
                            <span class="limit-exceeded">{{videoStandardDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="hc-included-config-red col-sm-3">
                    <div class="row">
                      <div
                        class="pricing-section-v3 pricing-section wow fadeIn"
                        style=""
                      >
                        <div class="pricing pricing--cluster">
                          <div class="pricing__item pricing__item--premium">
                            <div class="package__recommended">Premium</div>
                            <div class="pricing__price">
                              <span class="pricing__currency">$</span>{{videoPremiumCalculate}}
                            </div>
                            <p class="package__per__feature">per month</p>
                            <ul class="pricing__feature-list">
                              <li class="pricing__feature tooltip">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                7
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Include
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoPremium48Hours"
                                  type="radio"
                                  checked=""
                                  id="BSop1"
                                  name="BS1"
                                  :value="0"
                                />
                                <label for="BSop1">7 Days</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoPremium48Hours"
                                  type="radio"
                                  id="BSop11"
                                  name="BS1"
                                  :value="packages.video.premium.hosted_48_hours"
                                />
                                <label for="BSop11">48 Hours ($ {{packages.video.premium.hosted_48_hours}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                <input
                                  v-model="videoPremiumOffendersLocation"
                                  type="radio"
                                  checked=""
                                  id="BSop2"
                                  name="BS2"
                                  :value="0"
                                />
                                <label for="BSop2">No</label>
                                <i class="fa fa-check-circle"></i><br />

                                <input
                                  v-model="videoPremiumOffendersLocation"
                                  type="radio"
                                  id="BSop22"
                                  name="BS2"
                                  :value="packages.video.premium.sub_domains"
                                />
                                <label for="BSop22">Yes ($ {{packages.video.premium.sub_domains}})</label>
                                <i class="fa fa-check-circle"></i>
                              </li>

                              <li class="pricing__feature tooltip">
                                Unlimited
                                <i class="fa fa-check-circle"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Optional
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature optn">
                                <select v-model="videoPremiumAdditionalVideo">
                                  <option value="0">0 videos</option>
                                  <option v-for="index in packages.video.premium.additional_max_videos" :key="index" :value="index">{{index}} videos</option>
                                </select>
                                <span> ($ {{videoPremiumAdditionalCalculated}})</span>
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                Free
                                <i class="fa fa-window-close"></i>
                              </li>
                              <li class="pricing__feature tooltip">
                                24/7
                                <i class="fa fa-window-close"></i>
                              </li>
                            </ul>
                            <a class="pricing__action" href="#" :class="videoPremiumDisabled" v-on:click.prevent="videoPremiumSubmit">Choose now</a>
                            <span class="limit-exceeded">{{videoPremiumDisabledReason}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <p style="text-align: center;font-size: 14px;">* Prices are in US Dollars and exclude card fee of 3.5%.</p>
                  <p style="text-align: center;font-size: 14px;">* You shall pay 25% extra for each additional image or video content, if you turn on 48 hour service which is provided for an additional fee.</p>
                  <p style="text-align: center; font-size: 14px; margin-bottom: 80px;">* Personal content monitoring and removal (reputation/content management) fee starts from USD $999.</p>
                  <p style="text-align: center; font-weight: 600; font-size: 1.8em;">Customized Service Packages</p>
                  <p style="text-align: center; margin-bottom: 10px;">None of the above plans cover your needs? Contact us to create a customized flexible plan.</p>
                  <div class="wow fadeIn text-center">
                        <a
                          class="hc-btn-green purple"
                          href="/contact-us"
                          title
                          style="margin: 0 auto; max-width: 250px;"
                          >Contact Us</a
                        >
                      </div>
                </div>
              </div>
            </div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your IP",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "personal_harassment",
  computed: {
    imageBasicDisabled: function () {
      return this.imageBasicValidated ? "" : "disabled";
    },
    imageBasicDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imageBasicValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imageStandardDisabled: function () {
      return this.imageStandardValidated ? "" : "disabled";
    },
    imageStandardDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imageStandardValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imagePremiumDisabled: function () {
      return this.imagePremiumValidated ? "" : "disabled";
    },
    imagePremiumDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imagePremiumValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imageBasicCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { basic } = images || {}; 
      const { base, additional_images } = basic || {};
      let totalCalculated = base;

      if(this.imageBasic48Hours !== null) {
        totalCalculated += parseFloat(this.imageBasic48Hours);
      }
      
      if(this.imageBasicOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imageBasicOffendersLocation);
      }

      if(this.imageBasicAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageBasicAdditionalImages) * additional_images;

        this.imageBasicAdditionalCalculated = imagesCost;

        if(this.imageBasic48Hours == packages.images.basic.hosted_48_hours) {
          this.imageBasicAdditionalCalculated += imagesCost * packages.images.commission;
        }
        
        totalCalculated += this.imageBasicAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imageBasicValidated = false;
      } else {
        this.imageBasicValidated = true;
      }

      this.imageBasicSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    },
    imageStandardCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { standard } = images || {}; 
      const { base, additional_images } = standard || {};
      let totalCalculated = base;
      
      if(this.imageStandard48Hours !== null) {
        totalCalculated += parseFloat(this.imageStandard48Hours);
      }
      
      if(this.imageStandardOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imageStandardOffendersLocation);
      }

      if(this.imageStandardAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageStandardAdditionalImages) * additional_images;

        this.imageStandardAdditionalCalculated = imagesCost;

        if(this.imageStandard48Hours == packages.images.standard.hosted_48_hours) {
          this.imageStandardAdditionalCalculated += imagesCost * packages.images.commission;
        }
        
        totalCalculated += this.imageStandardAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imageStandardValidated = false;
      } else {
        this.imageStandardValidated = true;
      }

      this.imageStandardSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    },
    imagePremiumCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { premium } = images || {}; 
      const { base, additional_images } = premium || {};
      let totalCalculated = base;

      if(this.imagePremium48Hours !== null) {
        totalCalculated += parseFloat(this.imagePremium48Hours);
      }
      
      if(this.imagePremiumOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imagePremiumOffendersLocation);
      }

      if(this.imagePremiumAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imagePremiumAdditionalImages) * additional_images;

        this.imagePremiumAdditionalCalculated = imagesCost;

        if(this.imagePremium48Hours == packages.images.premium.hosted_48_hours) {
          this.imagePremiumAdditionalCalculated += imagesCost * packages.images.commission;
        }
        
        totalCalculated += this.imagePremiumAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imagePremiumValidated = false;
      } else {
        this.imagePremiumValidated = true;
      }

      this.imagePremiumSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    },
    videoBasicDisabled: function () {
      return this.videoBasicValidated ? "" : "disabled";
    },
    videoBasicDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoBasicValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoStandardDisabled: function () {
      return this.videoStandardValidated ? "" : "disabled";
    },
    videoStandardDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoStandardValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoPremiumDisabled: function () {
      return this.videoPremiumValidated ? "" : "disabled";
    },
    videoPremiumDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoPremiumValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoBasicCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { basic } = video || {}; 
      const { base, additional_videos } = basic || {};
      let totalCalculated = base;

      if(this.videoBasic48Hours !== null) {
        totalCalculated += parseFloat(this.videoBasic48Hours);
      }
      
      if(this.videoBasicOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoBasicOffendersLocation);
      }

      if(this.videoBasicAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoBasicAdditionalVideo) * additional_videos;
        this.videoBasicAdditionalCalculated = videoCost;

        if(this.videoBasic48Hours == packages.video.basic.hosted_48_hours) {
          this.videoBasicAdditionalCalculated += videoCost * packages.video.commission;
        }
        
        totalCalculated += this.videoBasicAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoBasicValidated = false;
      } else {
        this.videoBasicValidated = true;
      }

      this.videoBasicSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    },
    videoStandardCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { standard } = video || {}; 
      const { base, additional_videos } = standard || {};
      let totalCalculated = base;

      if(this.videoStandard48Hours !== null) {
        totalCalculated += parseFloat(this.videoStandard48Hours);
      }
      
      if(this.videoStandardOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoStandardOffendersLocation);
      }

      if(this.videoStandardAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoStandardAdditionalVideo) * additional_videos;
        this.videoStandardAdditionalCalculated = videoCost;

        if(this.videoStandard48Hours == packages.video.standard.hosted_48_hours) {
          this.videoStandardAdditionalCalculated += videoCost * packages.video.commission;
        }
        
        totalCalculated += this.videoStandardAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoStandardValidated = false;
      } else {
        this.videoStandardValidated = true;
      }

      this.videoStandardSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    },
    videoPremiumCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { premium } = video || {}; 
      const { base, additional_videos } = premium || {};
      let totalCalculated = base;

      if(this.videoPremium48Hours !== null) {
        totalCalculated += parseFloat(this.videoPremium48Hours);
      }
      
      if(this.videoPremiumOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoPremiumOffendersLocation);
      }

      if(this.videoPremiumAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoPremiumAdditionalVideo) * additional_videos;
        this.videoPremiumAdditionalCalculated = videoCost;

        if(this.videoPremium48Hours == packages.video.premium.hosted_48_hours) {
          this.videoPremiumAdditionalCalculated += videoCost * packages.video.commission;
        }
        
        totalCalculated += this.videoPremiumAdditionalCalculated;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoPremiumValidated = false;
      } else {
        this.videoPremiumValidated = true;
      }

      this.videoPremiumSelectedTotal = totalCalculated;

      return parseFloat(totalCalculated).toFixed(0);
    }
  },
  methods: {
    imageBasicSubmit: function () {
      if(this.imageBasicValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "IMAGE_BASIC",
          totalPrice: this.imageBasicSelectedTotal,
          hours48: parseFloat(this.imageBasic48Hours) > 0,
          offendersLocation: parseFloat(this.imageBasicOffendersLocation) > 0,
          additionalImages: parseFloat(this.imageBasicAdditionalImages)
        });

        this.$router.push("personal_sign_in");
      }
    },
    imageStandardSubmit: function () {
      if(this.imageStandardValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "IMAGE_STANDARD",
          totalPrice: this.imageStandardSelectedTotal,
          hours48: parseFloat(this.imageStandard48Hours) > 0,
          offendersLocation: parseFloat(this.imageStandardOffendersLocation) > 0,
          additionalImages: parseFloat(this.imageStandardAdditionalImages)
        });
        this.$router.push("personal_sign_in");
      }
    },
    imagePremiumSubmit: function () {
      if(this.imagePremiumValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "IMAGE_PREMIUM",
          totalPrice: this.imagePremiumSelectedTotal,
          hours48: parseFloat(this.imagePremium48Hours) > 0,
          offendersLocation: parseFloat(this.imagePremiumOffendersLocation) > 0,
          additionalImages: parseFloat(this.imagePremiumAdditionalImages)
        });
        this.$router.push("personal_sign_in");
      }
    },
    videoBasicSubmit: function () {
      if(this.videoBasicValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "VIDEO_BASIC",
          totalPrice: this.videoBasicSelectedTotal,
          hours48: parseFloat(this.videoBasic48Hours) > 0,
          offendersLocation: parseFloat(this.videoBasicOffendersLocation) > 0,
          additionalVideos: parseFloat(this.videoBasicAdditionalVideo)
        });

        this.$router.push("personal_sign_in");
      }
    },
    videoStandardSubmit: function () {
      if(this.videoStandardValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "VIDEO_STANDARD",
          totalPrice: this.videoStandardSelectedTotal,
          hours48: parseFloat(this.videoStandard48Hours) > 0,
          offendersLocation: parseFloat(this.videoStandardOffendersLocation) > 0,
          additionalVideos: parseFloat(this.videoStandardAdditionalVideo)
        });
        this.$router.push("personal_sign_in");
      }
    },
    videoPremiumSubmit: function () {
      if(this.videoPremiumValidated) {
        this.$store.commit({
          type: "selectedPackage",
          packageType: "VIDEO_PREMIUM",
          totalPrice: this.videoPremiumSelectedTotal,
          hours48: parseFloat(this.videoPremium48Hours) > 0,
          offendersLocation: parseFloat(this.videoPremiumOffendersLocation) > 0,
          additionalVideos: parseFloat(this.videoPremiumAdditionalVideo)
        });
        this.$router.push("personal_sign_in");
      }
    }
  },
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
      packages: this.$store.state.packages,
      imageBasicAdditionalCalculated: 0,
      imageBasic48Hours: 0,
      imageBasicValidated: false,
      imageBasicOffendersLocation: 0,
      imageBasicAdditionalImages: 0,
      imageBasicSelectedTotal: 0,
      imageStandardAdditionalCalculated: 0,
      imageStandard48Hours: 0,
      imageStandardValidated: false,
      imageStandardOffendersLocation: 0,
      imageStandardAdditionalImages: 0,
      imageStandardSelectedTotal: 0,
      imagePremiumAdditionalCalculated: 0,
      imagePremium48Hours: 0,
      imagePremiumValidated: false,
      imagePremiumOffendersLocation: 0,
      imagePremiumAdditionalImages: 0,
      imagePremiumSelectedTotal: 0,
      videoBasicAdditionalCalculated: 0,
      videoBasic48Hours: 0,
      videoBasicValidated: false,
      videoBasicOffendersLocation: 0,
      videoBasicAdditionalVideo: 0,
      videoBasicSelectedTotal: 0,
      videoStandard48Hours: 0,
      videoStandardAdditionalCalculated: 0,
      videoStandardValidated: false,
      videoStandardOffendersLocation: 0,
      videoStandardAdditionalVideo: 0,
      videoStandardSelectedTotal: 0,
      videoPremiumAdditionalCalculated: 0,
      videoPremium48Hours: 0,
      videoPremiumValidated: false,
      videoPremiumOffendersLocation: 0,
      videoPremiumAdditionalVideo: 0,
      videoPremiumSelectedTotal: 0,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.pricing__feature.choose-items {
  min-height: 72px;
}
.pricing__action {
  z-index: 99!important;
}
.pricing__action.disabled {
  pointer-events: none;
  background: #ccc;
}
.limit-exceeded {
    position: absolute;
    width: 100%;
    height: 50px;
    color: red;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/plans_pricing.vue